/**
 * This is a safe version of JSON.parse, where it returns an empty object instead of throwing.
 *
 * @param {string} sObj
 */
export function safeParse<T>(sObj: string): T {
    try {
        const result = JSON.parse(sObj);
        return result as T;
    }
    catch(err) {
        return {} as T;
    }
}